import * as Sentry from '@sentry/react';
import { browserTracingIntegration } from '@sentry/react';

// Initialize Sentry - silent monitoring only
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  integrations: [
    browserTracingIntegration({
      // Enable tracing for all domains
      tracingOrigins: [/.*/],
    }),
    // NO REPLAY - Privacy/GDPR compliance
  ],
  // Performance Monitoring
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
  // Allow tracing headers to all domains
  tracePropagationTargets: [/.*/], // All domains
  // Session Replay DISABLED - Privacy concerns
  replaysSessionSampleRate: 0, // Disabled
  replaysOnErrorSampleRate: 0, // Disabled
  // Capture unhandled promise rejections
  captureUnhandledRejections: true,
  // Set user context
  beforeSend(event, hint) {
    // Filter out non-error events in development
    if (process.env.NODE_ENV === 'development' && event.level !== 'error') {
      return null;
    }
    return event;
  },
  // Add custom tags
  initialScope: {
    tags: {
      component: 'fastig-gui',
    },
  },
});

export default Sentry;


